import { useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { useTranslation } from 'react-i18next';


const LogoutButton = () => {
  const { t } = useTranslation();

  const navigate = useNavigate();
  const { logout } = useAuth(); // Використовуємо `logout()` з контексту

  const handleLogout = () => {
    logout();
    navigate("/login"); // Перенаправляємо на сторінку входу
  };

  return (
    <button className="btn btn-danger" onClick={handleLogout}>
      {t("exit")}
    </button>
  );
};

export default LogoutButton;
